import React from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-6" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            Más los <span className="text-[#FFD700]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10" data-id="element-7">
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-8">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-9">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-10">
              Planificador Express "Clase en 10 Min"
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-11">
              12 mapas de clase listos por nivel · Plantilla maestra imprimible
              · Checklists pre y post clase
            </p>
            <div className="flex items-center gap-2" data-id="element-12">
              <span className="text-gray-400 line-through text-sm" data-id="element-13">$8.000</span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-14">
                GRATIS
              </span>
            </div>
          </div>

          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-15">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-16">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-17">
              Banco de Aperturas y Cierres
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-18">
              30 aperturas + 30 cierres con cliffhanger · 10 guiones de rescate
              · Tarjetas recortables
            </p>
            <div className="flex items-center gap-2" data-id="element-19">
              <span className="text-gray-400 line-through text-sm" data-id="element-20">$9.000</span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-21">
                GRATIS
              </span>
            </div>
          </div>

          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-22">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-23">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-24">
              Rotaciones Perfectas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-25">
              8 diagramas para cualquier combinación · Protocolos para números
              impares · 5 guiones exactos
            </p>
            <div className="flex items-center gap-2" data-id="element-26">
              <span className="text-gray-400 line-through text-sm" data-id="element-27">$8.000</span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-28">
                GRATIS
              </span>
            </div>
          </div>

          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-29">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-30">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-31">
              Kit de Evaluación + Certificados
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-32">
              3 tests por nivel · Rúbrica 0–10 · Guiones de devolución · 3
              certificados imprimibles
            </p>
            <div className="flex items-center gap-2" data-id="element-33">
              <span className="text-gray-400 line-through text-sm" data-id="element-34">
                $10.000
              </span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-35">
                GRATIS
              </span>
            </div>
          </div>

          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-36">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-37">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-38">
              Playlist Pedagógica ProfePack
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-39">
              36 tandas curadas por nivel · Consigna exacta por tanda · Matriz
              Orquesta × Objetivo
            </p>
            <div className="flex items-center gap-2" data-id="element-40">
              <span className="text-gray-400 line-through text-sm" data-id="element-41">$9.000</span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-42">
                GRATIS
              </span>
            </div>
          </div>

          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-5 flex flex-col" data-id="element-43">
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-44">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-base mb-1" data-id="element-45">
              Kit Imprimible de Fichas de Clase
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-3" data-id="element-46">
              24 fichas pro en A4/A5 · Técnica, figuras, musicalidad, corrección
              y seguimiento
            </p>
            <div className="flex items-center gap-2" data-id="element-47">
              <span className="text-gray-400 line-through text-sm" data-id="element-48">$7.000</span>
              <span className="bg-[#FFD700] text-black font-black text-xs px-3 py-1 rounded-full" data-id="element-49">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#FFD700]/40 rounded-2xl p-6 text-center bg-[#0d0a00]" data-id="element-50">
          <p className="text-[#FFD700] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-51">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-52">
            <span className="text-gray-400 line-through text-lg" data-id="element-53">$51.000</span>
            <span className="text-[#FFD700] text-2xl font-black tracking-wide" data-id="element-54">
              🎁 GRATIS — Incluidos siempre en las dos ofertas
            </span>
          </div>
        </div>
      </div>
    </section>;
}